import React from "react";
import TutorPaperAccessList from "./components/TutorPaperAccessList";

export default function TutorPapers() {
  return (
    <TutorPaperAccessList
      title="Papers"
      endpoint="tutor/papers"
      paperType="past_paper"
      pdfUrl={(id) => `tutor/paper/${id}/view-pdf`}
    />
  );
}
